export const PRE_PURCHASE_IMFORMATION =
  "https://assets.ctfassets.net/6efv05ymvl3z/5VKM4jFPHC4n5W672eRT6G/bc70816232fa9b3d83cc37f4c3b6a3a3/Brocc_f__rs__kringar_-_Produktinfoblad_Trygghetsf__rs__kring_efter_2023-01-01.pdf"
